(function () {

    'use strict';

    angular.module('asys')
        .component('asysKontakt', {
            bindings: {
                options: '<akOptions'
            },
            templateUrl: 'angebot/partials/kontakt.html',
            controller: KontaktController,
            controllerAs: 'kontaktVm'
        });

    KontaktController.$inject = [
        'AppConfig',
        'FormatUtilsService',
        'BasisAngebotService',
        'AngebotModel'
    ];

    function KontaktController(AppConfig, FormatUtilsService, BasisAngebotService, AngebotModel) {
        var vm = this,
            telefon;

        vm.$onInit = onInit;
        vm.$doCheck = doCheck;

        function onInit() {
            activate();
        }

        function doCheck() {
            telefon = BasisAngebotService.isPrivatPerson(AngebotModel.get().angebot) ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde;
        }

        function activate() {
            vm.options = vm.options || {};

            vm.phoneNumberDefault = {
                display: FormatUtilsService.formatPhoneNumber(telefon, {
                    removeInterantional: true,
                    replaceWhitespaceWithNonBreakingSpace: true
                }),
                call: 'tel:' + FormatUtilsService.formatPhoneNumber(telefon, {
                    internationalCode: '+49'
                })
            };

            vm.phoneNumberKundenservice = {
                display: FormatUtilsService.formatPhoneNumber(AppConfig.APP.telefonKundenservice, {
                    removeInterantional: true,
                    replaceWhitespaceWithNonBreakingSpace: true
                }),
                call: 'tel:' + FormatUtilsService.formatPhoneNumber(AppConfig.APP.telefonKundenservice, {
                    internationalCode: '+49'
                })
            };
        }
    }

})();
